// NavCreateButton.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Tooltip from '../component/Tooltip.jsx';
import { Icon, IconSection, TooltipStyle } from '../style/NavHeader.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { ButtonId } from '../resource/mixpanel.js';
import getNavigationIcon, {
  NavigationId,
} from '../resource/getNavigationIcon.js';
import defaults from '../resource/defaults.js';

export const NavCreateButton = ({
  isUploadMenuModalOpen = false,
  isBecomeCreatorModalOpen = false,
  openUploadMenuModal = defaults.NULL_FUNCTION,
}) => {
  const { t } = useTranslation();

  return (
    <IconSection>
      <Tooltip
        position="bottom-center"
        renderHint={() => (
          <TooltipStyle>
            {t('btn_create', {
              ns: TranslationNamespace.GENERAL,
            })}
          </TooltipStyle>
        )}
        trigger="hover"
      >
        <CreateIcon
          isMatch={isUploadMenuModalOpen || isBecomeCreatorModalOpen}
          aria-label={t('btn_create', {
            ns: TranslationNamespace.GENERAL,
          })}
          data-element_id={ButtonId.Tab.TabButtonCreate}
          onClick={openUploadMenuModal}
        >
          <img
            src={getNavigationIcon({
              navigationId: NavigationId.CREATE,
              isMatch: isUploadMenuModalOpen || isBecomeCreatorModalOpen,
            })}
            alt={t('btn_create', {
              ns: TranslationNamespace.GENERAL,
            })}
          />
        </CreateIcon>
      </Tooltip>
    </IconSection>
  );
};

NavCreateButton.propTypes = {
  isUploadMenuModalOpen: PropTypes.bool,
  isBecomeCreatorModalOpen: PropTypes.bool,
  openUploadMenuModal: PropTypes.func,
};

const CreateIcon = styled(Icon)``;

export default NavCreateButton;
